/*
 * @Date: 2019-12-08 17:13:38
 * @LastEditors: miaomiaodeng
 * @LastEditTime: 2020-03-11 16:52:10
 * @FilePath: /rongxin.web/src/views/home/index.js
 */
// component
import Navbar from '../../../components/navbar/index.vue';
import ProductService from '../../home/product-service/index.vue';
import contactUs from '../../home/contact-us/index.vue';
export default {
  name: 'home',
  components: {
    Navbar,
    ProductService,
    contactUs
  },
  data() {
    return {
      fromisActiveClass: 'productService',
      serviceArr: [
        {
          id: 1,
          imgUrl: require('../../../assets/images/product/pro1.png'),
          serviceTitle: '乡村资产数字化服务中心',
          tips: '结合大数据、区块链以及加密技术，对涉农资产进行数字化'
        },
        {
          id: 2,
          imgUrl: require('../../../assets/images/product/pro1.png'),
          serviceTitle: '乡村资产数字化监管平台',
          tips: '利用大数据、区块链、加密技术搭建的“乡村资产数字化监'
        },
        {
          id: 3,
          imgUrl: require('../../../assets/images/product/pro1.png'),
          serviceTitle: '乡村振兴金融服务平台',
          tips: '精准画像，建立信用    建模挖掘，资产有价  金融服务，资'
        },
        {
          id: 4,
          imgUrl: require('../../../assets/images/product/pro1.png'),
          serviceTitle: '数字农业社会化服务平台',
          tips: '建立标准化服务体系，提高服务效率、减少经营成本；打通'
        },
        {
          id: 5,
          imgUrl: require('../../../assets/images/product/pro5.png'),
          serviceTitle: '春耕APP',
          tips: '涵盖农村各类涉农信息的综合性服务平台，为终端农户连接'
        }
      ]
    };
  },
  created() {
    window.scrollTo(0, 0);
  },
  methods: {
    goHome() {
      this.$router.push({path: 'home'});
    },
    goProductDetail(paths, id) {
      this.$router.push(
        {
          path: paths,
          query: {
            id: id
          }
        });
    }
  }
};
